import { render } from "./NomineeProfile.vue?vue&type=template&id=7d3276e4&scoped=true"
import script from "./NomineeProfile.vue?vue&type=script&lang=js"
export * from "./NomineeProfile.vue?vue&type=script&lang=js"

import "./NomineeProfile.vue?vue&type=style&index=0&id=7d3276e4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d3276e4"]])

export default __exports__